/* eslint-disable no-console */
import { idpForUser } from '@lseg-ciam/auth/login';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { idpLookupUrls } from '../config.js';
import { rigSharedStyles } from './heimdall-rig-styles.js';

@customElement('heimdall-rig-idp-lookup')
export class HeimdallRigIdpLookup extends LitElement {
  @state()
  _userid = '';

  @state()
  _env: 'dev' | 'qa' | 'ppe' | 'prod' = 'dev';

  @state()
  _result = '';

  @state()
  _loading = false;

  onUseridChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    this._userid = target.value;
  }

  onEnvChanged(event: Event) {
    const target = event.target as HTMLSelectElement;
    this._env = target.value as 'dev' | 'qa' | 'ppe' | 'prod';
  }

  async onLookup() {
    if (!this._userid) {
      this._result = 'Error: userid is required';
      return;
    }

    this._loading = true;
    this._result = 'Loading...';

    try {
      const idp = await idpForUser({
        userid: this._userid,
        idpLookupUrl: idpLookupUrls[this._env],
      });

      this._result = `✓ IDP: ${idp}`;
      console.log(
        `%cIDP Lookup Result`,
        'background: lightgreen; color: navy; padding: 5px;',
        { userid: this._userid, env: this._env, idp }
      );
    } catch (e) {
      this._result = `Error: ${String(e)}`;
      console.error('idpForUser failed:', e);
    } finally {
      this._loading = false;
    }
  }

  onClear() {
    this._result = '';
  }

  render() {
    return html`
      <div class="app">
        <h1>IDP Lookup Rig</h1>
        <h2>${this._result || '—'}</h2>
        <ul>
          <li>
            <label>User ID (email)</label>
            <input
              type="text"
              @input=${this.onUseridChanged}
              .value=${this._userid}
              placeholder="user@lseg.com"
              ?disabled=${this._loading}
            />
          </li>
          <li>
            <label>Environment</label>
            <select
              @change=${this.onEnvChanged}
              .value=${this._env}
              ?disabled=${this._loading}
            >
              <option value="dev">dev</option>
              <option value="qa">qa</option>
              <option value="ppe">ppe</option>
              <option value="prod">prod</option>
            </select>
          </li>
          <li>
            <button
              @click=${this.onLookup}
              ?disabled=${this._loading || !this._userid}
            >
              Lookup IDP
            </button>
            <button @click=${this.onClear} ?disabled=${this._loading}>
              Clear
            </button>
          </li>
        </ul>
      </div>
    `;
  }

  static styles = rigSharedStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-rig-idp-lookup': HeimdallRigIdpLookup;
  }
}
